(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vtx-curation"] && !Shopify.designMode) return;
  try {
    
function initVtxCarousels(root=document){root.querySelectorAll('.vtx-curation').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const track=section.querySelector('.vtx-track');if(!track)return;const move=direction=>track.scrollBy({left:direction*(track.querySelector('li').getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});section.querySelector('[data-vtx-prev]').addEventListener('click',()=>move(-1));section.querySelector('[data-vtx-next]').addEventListener('click',()=>move(1));});}initVtxCarousels();document.addEventListener('shopify:section:load',event=>initVtxCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vtx-guide"]) return;
  try {
    
function vtxQuizRecommendation(a,available){
 const has=k=>available.includes(k),out=[];
 const add=k=>{if(has(k)&&!out.includes(k))out.push(k)};
 const priorities=a.prio||[],allowInternal=a.est==='int'||a.est==='duo';
 const appMismatch=allowInternal&&priorities.includes('app');
 if(a.meta==='cuidar')add('nectar');
 if(a.est==='ext'||a.est==='nao')add('alba');
 else if(!appMismatch){
  if(a.est==='int')add('tuberosa');
  else if(priorities.includes('var'))add('nocturna');
  else add('tuberosa');
  if(a.est==='duo'&&a.exp==='alto'&&priorities.includes('var'))add('triade');
 }
 if(a.meta==='dois')add('amanhecer');
 if(priorities.includes('ritual')||a.meta==='cuidar'||a.meta==='dois')add('nectar');
 return {handles:out.slice(0,3),appMismatch,unknown:a.est==='nao'};
}
function initVtxReferenceQuiz(scope=document){scope.querySelectorAll('[data-vtx-refquiz]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const copy=JSON.parse(root.querySelector('[data-quiz-copy]').textContent),Q=copy.questions;
 const app=root.querySelector('[data-quiz-app]'),result=root.querySelector('[data-quiz-result]'),counter=root.querySelector('[data-quiz-count]');
 const cards=[...root.querySelectorAll('[data-recommendation]')],available=cards.map(x=>x.dataset.recommendation);
 let answers={},step=0;
 const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const show=()=>{
  result.hidden=true;app.hidden=false;const q=Q[step],sel=answers[q.id]||(q.multi?[]:null);
  counter.textContent=copy.progress.replace('{current}',step+1);
  let h='<div class="vtx-rq__bar" role="progressbar" aria-label="'+esc(copy.progress.replace('{current}',step+1))+'" aria-valuemin="1" aria-valuemax="4" aria-valuenow="'+(step+1)+'"><span style="width:'+((step+1)*25)+'%"></span></div><h1 tabindex="-1">'+esc(q.t)+'</h1><p class="vtx-rq__muted">'+esc(q.s)+'</p><div class="vtx-rq__options">';
  q.o.forEach(o=>{const on=q.multi?sel.includes(o[0]):sel===o[0];h+='<button type="button" class="vtx-rq__option" data-value="'+o[0]+'" aria-pressed="'+on+'"><strong>'+esc(o[1])+'</strong><span>'+esc(o[2])+'</span></button>'});
  h+='</div><p class="vtx-rq__notice" data-quiz-error role="status" hidden></p><div class="vtx-rq__nav">'+(step?'<button type="button" class="vtx-rq__back" data-quiz-back>'+esc(copy.back)+'</button>':'<span></span>')+'<button type="button" class="button" data-quiz-next '+((q.multi?sel.length:sel)?'':'disabled')+'>'+esc(step===3?copy.finish:copy.next)+'</button></div>';
  app.innerHTML=h;app.querySelector('h1').focus({preventScroll:true});
  app.querySelectorAll('[data-value]').forEach(b=>b.addEventListener('click',()=>{
   const value=b.dataset.value;
   if(q.multi){const selected=answers[q.id]||[];if(selected.includes(value))answers[q.id]=selected.filter(v=>v!==value);else if(selected.length<q.multi)answers[q.id]=[...selected,value];else{const error=app.querySelector('[data-quiz-error]');error.textContent=copy.limit;error.hidden=false;return;}}
   else answers[q.id]=value;
   app.querySelectorAll('[data-value]').forEach(button=>button.setAttribute('aria-pressed',q.multi?answers[q.id].includes(button.dataset.value):answers[q.id]===button.dataset.value));
   const error=app.querySelector('[data-quiz-error]');error.hidden=true;app.querySelector('[data-quiz-next]').disabled=!(q.multi?answers[q.id].length:answers[q.id]);
  }));
  const back=app.querySelector('[data-quiz-back]');if(back)back.addEventListener('click',()=>{step--;show()});
  app.querySelector('[data-quiz-next]').addEventListener('click',()=>{if(!answers[q.id]||(q.multi&&!answers[q.id].length))return;if(step<3){step++;show()}else renderResult()});
 };
 const renderResult=()=>{
  const picked=vtxQuizRecommendation(answers,available);app.hidden=true;result.hidden=false;counter.textContent='';
  const level=['zero','pouco'].includes(answers.exp)?'start':answers.exp==='medio'?'mid':'high';
  result.querySelector('[data-result-title]').textContent=copy[level+'_title'];result.querySelector('[data-result-intro]').textContent=copy[level+'_text'];
  result.querySelector('[data-app-mismatch]').hidden=!picked.appMismatch;result.querySelector('[data-unknown]').hidden=!picked.unknown;
  result.querySelector('[data-empty]').hidden=picked.handles.length>0;
  cards.forEach(c=>{c.hidden=!picked.handles.includes(c.dataset.recommendation)});
  const products=result.querySelector('[data-result-products]');picked.handles.forEach(h=>products.appendChild(cards.find(c=>c.dataset.recommendation===h)));
  const guideKey={conhecer:'pleasure',prazer:'solo',dois:'company',cuidar:'care'}[answers.meta];
  result.querySelectorAll('[data-result-guide]').forEach(g=>g.hidden=g.dataset.resultGuide!==guideKey);
  result.querySelector('h1').focus();
 };
 root.querySelector('[data-quiz-edit]').addEventListener('click',()=>{step=0;show()});root.querySelector('[data-quiz-redo]').addEventListener('click',()=>{answers={};step=0;show()});
 root.querySelector('[data-quiz-nojs]').hidden=true;show();
})}
initVtxReferenceQuiz();document.addEventListener('shopify:section:load',event=>initVtxReferenceQuiz(event.target));


  } catch(e) { console.error(e); }
})();
})();
